import {
  Box,
  Typography,
  Button,
  Modal,
  CircularProgress,
} from "@mui/material";
import { useState, useEffect } from "react";
import { getInspStatusImage } from "../../services/inspectService.js";

export default function UnitInfoModal({
  open,
  onClose,
  selectedUnit,
  selectedRow,
  inspectionType,
  selectedImagePath,
  setSelectedImagePath,
  image,
  setImage,
}) {
  const [hoveredPath, setHoveredPath] = useState(null);
  const [ngCount, setNgCount] = useState(0);
  const [unitInfo, setUnitInfo] = useState(null);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    if (selectedUnit) {
      setUnitInfo(selectedUnit);
      if (inspectionType === "AVI") {
        setNgCount(selectedUnit.filter((data) => data.review !== null).length);
      } else {
        setNgCount(selectedUnit.filter((data) => data.label === "NG").length);
      }
    }
  }, [selectedUnit]);

  if (!selectedUnit) return null;

  const handleImageClick = async (path) => {
    try {
      setSelectedImagePath(path);
      const image = await getInspStatusImage(path);
      setImage(image);
    } catch (error) {
      console.error("이미지 로딩 중 에러:", error);
    }
  };

  const handleDownloadImage = () => {
    const fileName = selectedImagePath.split("/").pop();

    if (selectedImagePath) {
      const link = document.createElement("a");
      link.href = image;
      link.download = fileName;
      link.click();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box
          sx={{
            borderBottom: "2px solid #e0e0e0",
            pb: 2,
            mb: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "var(--main-color)",
            }}
          >
            Unit Information
          </Typography>
        </Box>
        {selectedRow ? (
          <>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                gap: 2,
                mb: 3,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Lot:
              </Typography>
              <Typography>{selectedRow.lot}</Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Zone:
              </Typography>
              <Typography>{selectedRow.zone}</Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Status ({inspectionType === "AVI" ? "AVI" : "AI"} 기준) :
              </Typography>
              <Typography>
                <Box
                  component="span"
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                    backgroundColor:
                      selectedRow.label === "NG" ? "#ffebee" : "#e8f5e9",
                    color: selectedRow.label === "NG" ? "#d32f2f" : "#2e7d32",
                    fontWeight: "medium",
                  }}
                >
                  {selectedRow.label}
                </Box>
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Count:
              </Typography>
              {inspectionType === "AVI" ? (
                <Typography>
                  {ngCount}/{selectedRow.image_count}
                </Typography>
              ) : (
                <Typography>
                  {ngCount}/{selectedRow.image_count}
                </Typography>
              )}

              <Typography
                sx={{
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Location:
              </Typography>
              <Typography>
                ({selectedRow.x}, {selectedRow.y})
              </Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                }}
              >
                Images:
              </Typography>
              <Box sx={{ display: "flex", gap: 2, overflow: "hidden" }}>
                <Box
                  sx={{
                    width: "50%",
                    height: "400px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    overflowX: "auto",
                    overflowY: "auto",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Box
                    sx={{
                      p: 1,
                      borderBottom: "1px solid #e0e0e0",
                      backgroundColor: "#f5f5f5",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      width: "100%",
                    }}
                  >
                    {inspectionType === "AVI" ? (
                      <Box
                        component="span"
                        sx={{
                          minWidth: "45px",
                          textAlign: "center",
                          fontSize: "0.875rem",
                          fontWeight: "bold",
                        }}
                      >
                        AVI
                      </Box>
                    ) : (
                      <Box
                        component="span"
                        sx={{
                          minWidth: "45px",
                          textAlign: "center",
                          fontSize: "0.875rem",
                          fontWeight: "bold",
                        }}
                      >
                        AI
                      </Box>
                    )}
                    <Box
                      component="span"
                      sx={{
                        minWidth: "45px",
                        textAlign: "center",
                        fontSize: "0.875rem",
                        fontWeight: "bold",
                        ml: 1,
                      }}
                    >
                      HR
                    </Box>
                    <Typography
                      sx={{
                        ml: 1,
                        flex: 1,
                        fontSize: "0.875rem",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Image Name
                    </Typography>
                  </Box>
                  {unitInfo?.map((data, index) => (
                    <Box
                      key={data.path}
                      onClick={() => handleImageClick(data.path)}
                      sx={{
                        p: 1,
                        cursor: "pointer",
                        backgroundColor:
                          hoveredPath === data.path
                            ? "rgba(25, 118, 210, 0.08)"
                            : "transparent",
                        borderRadius: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        transition: "background-color 0.2s",

                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                    >
                      {inspectionType === "AVI" ? (
                        <Box
                          component="span"
                          sx={{
                            borderRadius: 1,
                            backgroundColor: data.review
                              ? "#ffebee"
                              : "#e8f5e9",
                            color: data.review ? "#d32f2f" : "#2e7d32",
                            fontSize: "0.875rem",
                            fontWeight: "medium",
                            px: 0.5,
                            py: 0.5,
                            minWidth: "45px",
                            textAlign: "center",
                          }}
                        >
                          {data.review ? "NG" : "OK"}
                        </Box>
                      ) : (
                        <Box
                          component="span"
                          sx={{
                            borderRadius: 1,
                            backgroundColor:
                              data.label === "NG" ? "#ffebee" : "#e8f5e9",
                            color: data.label === "NG" ? "#d32f2f" : "#2e7d32",
                            fontSize: "0.875rem",
                            fontWeight: "medium",
                            px: 0.5,
                            py: 0.5,
                            minWidth: "45px",
                            textAlign: "center",
                          }}
                        >
                          {data.label}
                        </Box>
                      )}
                      <Box
                        component="span"
                        sx={{
                          borderRadius: 1,
                          backgroundColor: data.review
                            ? data.review === "NG"
                              ? "#ffebee"
                              : "#e8f5e9"
                            : "transparent",
                          color: data.review
                            ? data.review === "NG"
                              ? "#d32f2f"
                              : "#2e7d32"
                            : "#000000",
                          fontSize: "0.875rem",
                          fontWeight: "medium",
                          ml: 1,
                          px: 0.5,
                          py: 0.5,
                          minWidth: "45px",
                          textAlign: "center",
                        }}
                      >
                        {data.review ? data.review : "-"}
                      </Box>
                      <Typography
                        sx={{
                          ml: 1,
                          px: 0.5,
                          py: 0.5,
                          flex: 1,
                          color: "#555",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {data.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    width: "50%",
                    height: "400px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {image ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 2,
                      }}
                    >
                      <img
                        src={image}
                        alt={`Preview ${selectedImagePath}`}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  ) : (
                    <Typography sx={{ color: "#999" }}>
                      Hover over an image name to preview
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              {image && (
                <Button onClick={() => handleDownloadImage()}>
                  이미지 다운로드
                </Button>
              )}
              <Button onClick={onClose}>Close</Button>
            </Box>
          </>
        ) : (
          <Box>
            <CircularProgress style={{ color: "var(--text-color)" }} />
          </Box>
        )}
      </Box>
    </Modal>
  );
}
